import { BooleanCons, NumberCons, StringConst } from '../../constants/const';
import { BaseResponseHttp } from './commons.model';
import {
  ChangeMethodToInvoiseRequest,
  DeletePackages,
  PackageValidation,
} from './invoices-Pending';
import { PaymentMethod } from './ordersresume.model';
import { PaymentInformation } from '../local/payment.model';

export class IPaymentMethodRes extends BaseResponseHttp {
  response?: ChangePaymentMethod;
}

export class ChangePaymentMethod {
  method: string;
  creationDate: Date;
  dueDate: Date;
  totalCost: number;
  iva: number;
  subtotal: number;
  hourLeftToExpire: number;
  costShipping: number;
  totalDiscount: number;
  isShippingCostAccepted: boolean;
  paymentMethod: PaymentInformation;
  barcodeUrl?: string;
  hasDiscountSpecial: boolean;
  percentDiscountSpecial: number;
  discountSpecialAmount: number;
  creditNoteAmount: number;
  promotionalCodeAmount: number;
  costShippingDiscount: number;
  constructor() {
    this.method = StringConst.empty;
    this.creationDate = new Date();
    this.dueDate = new Date();
    this.totalCost = NumberCons.zero;
    this.iva = NumberCons.zero;
    this.subtotal = NumberCons.zero;
    this.hourLeftToExpire = NumberCons.zero;
    this.paymentMethod = new PaymentInformation();
    this.barcodeUrl = StringConst.empty;
    this.costShipping = NumberCons.zero;
    this.totalDiscount = NumberCons.zero;
    this.isShippingCostAccepted = BooleanCons.false;
    this.hasDiscountSpecial = BooleanCons.false;
    this.percentDiscountSpecial = NumberCons.zero;
    this.creditNoteAmount = NumberCons.zero;
    this.discountSpecialAmount = NumberCons.zero;
    this.promotionalCodeAmount = NumberCons.zero;
    this.costShippingDiscount = NumberCons.zero;
  }
}

export class PaymentMethodOperations extends ChangeMethodToInvoiseRequest {
  isPaymentExpired: boolean;
  userUpdate: string;
  oldTransactionId: string;
  doctorSpeciality: string;
  priceListId: number;
  clientType: string;
  monthlyInstallments?: number | null;
  constructor() {
    super();
    this.isPaymentExpired = BooleanCons.false;
    this.userUpdate = StringConst.empty;
    this.oldTransactionId = StringConst.empty;
    this.doctorSpeciality = StringConst.empty;
    this.priceListId = NumberCons.zero;
    this.clientType = StringConst.empty;
    this.monthlyInstallments = null;
  }
}

export class PaymentMethodResponse {
  paymentMethod: DetailPayment;
  method: string;
  creationDate: string;
  dueDate: string;
  totalCost: number;
  iva: number;
  subtotal: number;
  hourLeftToExpire: number;
  constructor() {
    this.creationDate = StringConst.empty;
    this.dueDate = StringConst.empty;
    this.hourLeftToExpire = NumberCons.zero;
    this.iva = NumberCons.zero;
    this.method = StringConst.empty;
    this.subtotal = NumberCons.zero;
    this.totalCost = NumberCons.zero;
    this.paymentMethod = new DetailPayment();
  }
}

export class DetailPayment {
  type: string;
  bankName: string;
  agreement: string;
  clabe: string;
  name: string;
  reference: string;
  barcodeUrl: string;
  bussinessName: string;

  constructor() {
    this.agreement = StringConst.empty;
    this.bankName = StringConst.empty;
    this.barcodeUrl = StringConst.empty;
    this.bussinessName = StringConst.empty;
    this.clabe = StringConst.empty;
    this.name = StringConst.empty;
    this.reference = StringConst.empty;
    this.type = StringConst.empty;
  }
}

export class GenerateNewSpeiCodeRequest {
  transactionId: string;
  email: string;
  doctorName: string;
  cardCode: string;
  packageValidation: DeletePackages;
  userUpdate: string;
  oldTransactionId: string;
  constructor() {
    this.transactionId = StringConst.empty;
    this.email = StringConst.empty;
    this.doctorName = StringConst.empty;
    this.cardCode = StringConst.empty;
    this.packageValidation = new DeletePackages();
    this.userUpdate = StringConst.empty;
    this.oldTransactionId = StringConst.empty;
  }
}
